import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import GatePass from "./pages/GatePass";
import Stock from "./pages/Stock";
import PublicGatePass from "./pages/PublicGatePass";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CashBook from "./pages/CashBook";
import CreditParties from "./pages/CreditParties";
import CreditPartyLedger from "./pages/CreditPartyLedger";
import Parties from "./pages/Parties";
import Settings from "./pages/Settings";
import SuperAdmin from "./pages/SuperAdmin";
import AdminUsers from "./pages/AdminUsers";
import Vouchers from "./pages/Vouchers";
import CapitalAccounts from "./pages/CapitalAccounts";
import Invoices from "./pages/Invoices";
import StoreInvoices from "./pages/StoreInvoices";
import PendingPayments from "./pages/PendingPayments";
import Reports from "./pages/Reports";
import Salary from "./pages/Salary";
import EmployeeLedger from "./pages/EmployeeLedger";
import Assets from "./pages/Assets";
import Analytics from "./pages/Analytics";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Team from "./pages/Team";
import Approvals from "./pages/Approvals";
import OwnerDashboard from "./pages/OwnerDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/gp/:token" element={<PublicGatePass />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/cashbook" element={<ProtectedRoute><CashBook /></ProtectedRoute>} />
          <Route path="/credit" element={<ProtectedRoute><CreditParties /></ProtectedRoute>} />
          <Route path="/credit/:id" element={<ProtectedRoute><CreditPartyLedger /></ProtectedRoute>} />
          <Route path="/capital-accounts" element={<ProtectedRoute><CapitalAccounts /></ProtectedRoute>} />
          <Route path="/parties" element={<ProtectedRoute><Parties /></ProtectedRoute>} />
          <Route path="/vouchers" element={<ProtectedRoute><Vouchers /></ProtectedRoute>} />
          <Route path="/gatepass" element={<ProtectedRoute><GatePass /></ProtectedRoute>} />
          <Route path="/stock" element={<ProtectedRoute><Stock /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/store-invoices" element={<ProtectedRoute><StoreInvoices /></ProtectedRoute>} />
          <Route path="/pending-payments" element={<ProtectedRoute><PendingPayments /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/salary" element={<ProtectedRoute><Salary /></ProtectedRoute>} />
          <Route path="/salary/:id/ledger" element={<ProtectedRoute><EmployeeLedger /></ProtectedRoute>} />
          <Route path="/assets" element={<ProtectedRoute><Assets /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
          <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
          <Route path="/owner" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute requireSuperadmin><SuperAdmin /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requireSuperadmin><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute requireSuperadmin><Analytics /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
